import React, { useRef } from "react";
import { RewardType } from "../../../interface/interface";

function RewardCard({
  data,
  __update,
  index,
}: {
  data: RewardType;
  __update: (
    type: string,
    payload: string | number,
    index: number | undefined
  ) => void;
  index: number;
}) {
  return (
    <div className="reward-card">
      <img
        src="/assets/common/cancel.svg"
        alt=""
        className="cancel"
        onClick={() => {
          __update("rewards/remove", "", index);
        }}
      />
      <div className="title">완주 보상</div>
      <div className="content">
        <div className="input-wrapper">
          <input
            type="text"
            placeholder="예 )  팀플 입사 지원 시 서류 면제권"
            value={data.bnfit_nm}
            onChange={(e) => {
              if (e.target.value.length < 36) {
                __update("rewards/title", e.target.value, index);
              }
            }}
          />
          <div className="length">{data.bnfit_nm.length}/35</div>
        </div>
        <div className="check-wrapper">
          <div
            className="circle"
            onClick={() => {
              __update("rewards/fg", "", index);
            }}
          >
            {data.bnfit_impt_fg ? (
              <img alt="" src="/assets/common/check.svg" />
            ) : undefined}
          </div>
          <div className="title">중요 보상</div>
        </div>
      </div>
    </div>
  );
}

export default RewardCard;
